import pastasGerencias from '~/graphql/pre-defined-filters/pastasGerencias';
import pastasResponsaveis from '~/graphql/pre-defined-filters/pastasResponsaveis';

interface PastasAtivasOptions {
  gerencia?: number;
  responsaveis?: string[];
}

export default function (options?: PastasAtivasOptions) {
  const baseFilter = {
    status: {
      eq: 2,
    },
    pastaPrincipalCodigo: {
      eq: null,
    },
  };

  const ands: any[] = [baseFilter];

  if (options?.gerencia) {
    ands.push(pastasGerencias(options.gerencia));
  }

  if (options?.responsaveis && options?.responsaveis.length > 0) {
    ands.push(pastasResponsaveis(options.responsaveis));
  }

  return {
    where: {
      and: ands,
    },
  };
}
